/**
 * @author: Pawan Singh Sisodiya
 */
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Confirm from "../Confirm";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { ShimmerTable } from "react-shimmer-effects";
import InfoPill from "../InfoPill";
import schoolApi from "../../api/schoolApi";
import { usePermissions } from "../contexts/PermissionContext";
import Select from "react-select";
import { SessionContext } from "../SessionProvider";

// fees can never be negative: blocks "-", "e", "+" and values below 0
const isNegativeInput = (v) => {
  const s = String(v ?? "").trim();
  return s.includes("-") || /[eE+]/.test(s) || (s !== "" && Number(s) < 0);
};


const getBaseStem = (str) => {
  let s = (str || "").trim().toLowerCase();
  if (/(?:s|x|z|ch|sh)es$/.test(s)) {
    return s.slice(0, -2);
  }
  if (/s$/.test(s) && !/ss$/.test(s) && s.length > 3) {
    return s.slice(0, -1);
  }
  return s;
};

const FeeDiscount = (props) => {
  const [body, setBody] = useState();
  const [discountRecords, setDiscountRecords] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [rowRecords, setRowRecords] = useState([]);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [sessionYear, setSessionYear] = useState([]);
  const [feeHeads, setFeeHeads] = useState([{}]);
  const { rolePermissions, userInfo } = usePermissions();
  const [optionFeeHeadMaster, setFeeHeadMaster] = useState([]);
  const [selectedFeeHeadMaster, setSelectedFeeHeadMaster] = useState([]);
  const canCreate = rolePermissions?.Fee_Discount_Master?.can_create;
  const canEdit = rolePermissions?.Fee_Discount_Master?.can_edit;
  const { selectedSessionId, setSelectedSessionId, currentSessionId } =
  useContext(SessionContext);
  const [isCurrentSession,setIsCurrentSession] = useState();
  

  useEffect(() => {
      async function init() {
        try {
          if (currentSessionId !== null && currentSessionId !== undefined) {
            setIsCurrentSession(selectedSessionId === currentSessionId);
          }
        } catch (error) {
          console.log('error=>', error);
        }
      }
      init();
    }, [selectedSessionId,isCurrentSession]);

  useEffect(() => {
    async function init() {
      try {
        const result = await schoolApi.fetchFeeDiscounts(selectedSessionId);

        console.log("result--->>",result)
        
        let newObj = {
          discount: result.result,
        };

        console.log('newobj',newObj)
        let arr = newObj?.discount?.map((element) => {
          return {
            id: element.discount.id,
            name: element.discount.name,
            percent: element.discount.percent,
            amount: element.discount.amount,
            fee_head_id: element.discount.fee_head_id,
            status: element.discount.status,
            sessionid: element.discount.sessionid,
            heads: element.heads,
            session: element.session,
          };
        });

        if (arr) {
          setBody(arr);
          // setDiscountRecords selectedSession_Id from context.  | 13-Feb-2025 | sarfraj
          setDiscountRecords((prevState) => ({
            ...prevState,
            sessionid: selectedSessionId,
          }))
        } else {
          setBody([]);
        }
      } catch (error) {
        console.log('error-in-FeeDiscount-->>' , error);
      }
    }
    init();
  }, [reload , selectedSessionId]);

  useEffect(() => {
    async function getSessions() {
      try {
        const sessions = await schoolApi.fetchSessions();
        const feeHeadsResult = await schoolApi.fetchFeesHeadMaster();

        if (feeHeadsResult.success) {
          const updatedFeeHeads = feeHeadsResult?.result?.map((res) => ({
            label: res.id,
            value: res.name,
          }));

          setFeeHeads(updatedFeeHeads);
        } else {
          setFeeHeads([]);
        }
        if (sessions.success) {
          setSessionYear(sessions.result);
        } else {
          setSessionYear([]);
        }
      } catch (error) {}
    }

    async function initFeeHeadMaster() {
      try {
        const feeHeadMaster = await schoolApi.fetchFeesHeadMaster();
        if (feeHeadMaster.success) {
          let ar = feeHeadMaster?.result?.map((item) => ({
            value: item.id,
            label: item.name,
          }));
          setFeeHeadMaster(ar);
        } else {
          setFeeHeadMaster([]);
        }
      } catch (error) {}
    }

    getSessions();
    initFeeHeadMaster();
  }, [selectedSessionId]); // fetch All data before open Modal.
  // }, [showModal]);

  const labels = {
    beforeSelect: " ",
  };

  const header = [
    {
      title: "Name",
      prop: "name",
      isFilterable: true,
      show: true,
    },
    {
      title: "Percent (%)",
      prop: "percent",
      isFilterable: true,
      show: true,
    },
    {
      title: "Amount",
      prop: "amount",
      isFilterable: true,
      show: true,
    },
    {
      title: "Session",
      prop: "session",
      isFilterable: true,
      show: true,
    },
    {
      title: "Fee Head",
      prop: "heads",
      show: true,
      isFilterable: true,
      cell: (row) =>
        row?.heads?.map((headname) => headname.headname).join(", "),
    },
    {
      title: "Status",
      prop: "status",
      isFilterable: true,
      show: true,
      cell: (row) => (
        <Button
          className="btn-sm mx-2"
          style={{ width: "80px" }}
          disabled={isCurrentSession === false?true:false}
          variant={row.status === "Active" ? "success" : "danger"}
          onClick={() => toggleStatus(row)}
        >
          {row.status}
        </Button>
      ),
    },
    {
      title: "Action",
      prop: "",
      isFilterable: true,
      show:
        userInfo?.userrole === "SYS_ADMIN" || userInfo?.userrole === "ADMIN"
          ? true
          : canEdit,
      cell: (row) =>
        (userInfo?.userrole === "SYS_ADMIN" ||
          userInfo?.userrole === "ADMIN" ||
          canEdit) && (
          <div>
            <button
              className="btn btn-sm edit-button mx-2"
              onClick={() => handleEditButton(row)}
              disabled={isCurrentSession === false?true:false}
            >
              <i className="fa-regular fa-pen-to-square"></i>
            </button>
          </div>
        ),
    },
  ];

  const handleEditButton = (row) => {
    setDiscountRecords(row);
    setShowModal(true);
    let obj = row?.heads?.map((ele) => {
      return {
        value: ele.fee_head_id,
        label: ele.headname,
      };
    });

    setSelectedFeeHeadMaster(obj);
  };

  const toggleStatus = (row) => {
    if (
      canEdit ||
      userInfo?.userrole === "SYS_ADMIN" ||
      userInfo?.userrole === "ADMIN"
    ) {
      setUpdateStatus(true);
      setRowRecords(row);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedFeeHeadMaster([]);
    setDiscountRecords({sessionid: selectedSessionId});
  };

  const handleChange = (e) => {

    if ((e.target.name === "percent" || e.target.name === "amount") && (isNaN(e.target.value) || isNegativeInput(e.target.value))) {
      return;
    }

    if (e.target.name === "amount") {
      if (e.target.value.includes(" ")) {
        return;
      }
    }

    if (e.target.name === "percent") {
      if (e.target.value.includes(" ")) {
        return;
      }
      if (e.target.value <= 100 && e.target.value >= 0) {
        setDiscountRecords((prevState) => ({
          ...prevState,
          [e.target.name]: e.target.value,
        }));
      }
      return;
    }

    setReload(false);
    setDiscountRecords((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSaveNewDiscount = async () => {
    try {
      if (
        !discountRecords.name ||
        !discountRecords.status ||
        !discountRecords.sessionid
      ) {
        return toast.error("Missing required fields");
      }

      if (!discountRecords.percent && !discountRecords.amount) {
        return toast.error("Enter Amount or Percent!!!");
      }

      const cleanName = (discountRecords.name || "").trim();
      const lowerName = cleanName.toLowerCase();
      const inputStem = getBaseStem(cleanName);

      const existingDuplicate = (body || []).find((item) => {
        if (discountRecords.id && item.id === discountRecords.id) {
          return false;
        }
        const itemLower = (item.name || "").trim().toLowerCase();
        if (itemLower === lowerName) return true;
        return getBaseStem(itemLower) === inputStem;
      });

      if (existingDuplicate) {
        return toast.error(
          `Fees Discount '${cleanName}' already exists as '${existingDuplicate.name}' in this session!`
        );
      }

      if (lowerName === "other" || lowerName === "others") {
        discountRecords.name = "Other";
      } else {
        discountRecords.name = cleanName;
      }

      setReload(false);

      if (discountRecords.id) {
        const id = discountRecords.id;
        delete discountRecords.heads;

        discountRecords.amount = discountRecords.amount
          ? discountRecords.amount
          : 0;
        discountRecords.percent = discountRecords.percent
          ? discountRecords.percent
          : 0;

        const result2 = await schoolApi.updateFeeDiscounts(id, discountRecords);
        if (result2?.success) {
          setReload(true);
          setShowModal(false);
          setDiscountRecords({});
          setSelectedFeeHeadMaster([]);
          return toast.success("Record updated successfully");
        } else {
          setReload(true);
          return toast.error(result2.message || "Error updating record");
        }
      } else {
        const result = await schoolApi.createFeeDiscounts(discountRecords);
        if (result?.success) {
          setReload(true);
          setShowModal(false);
          setDiscountRecords({});
          setSelectedFeeHeadMaster([]);
          return toast.success("Record saved successfully");
        } else {
          setReload(true);
          return toast.error(result?.message || "Error saving record");
        }
      }
    } catch (error) {}
  };

  console.log('rowRecords-before->',rowRecords);
  // const changeDiscountStatus = async () => {
  //   try {
  //     const prevStatus = rowRecords.status;
  //     console.log("rowRecords.status =>", rowRecords.status);
  //     console.log("rowRecords=>", rowRecords);

  //     const newStatus = prevStatus === "Active" ? "Inactive" : "Active";
  //     console.log('newStatus-->',newStatus);

  //     const recordinrow = { ...rowRecords };
  //     console.log('recordinrow-->',recordinrow);
  //     delete recordinrow.heads;
  //     newStatus.status = newStatus;

  //     const result = await schoolApi.updateFeeDiscounts(
  //       recordinrow.id,
  //       recordinrow
  //     );
  //     console.log("result->", result);

  //     if (result.success) {
  //      // rowRecords.status = newStatus;
  //       setUpdateStatus(false);
  //     } else {
  //       setUpdateStatus(false);
  //       toast.error(result.message);
  //       //rowRecords.status = prevStatus;
  //     }
  //   } catch (error) {
  //     toast.error(error.response?.data?.message );
  //   }
  // };

  const changeDiscountStatus = async () => {
    try {
      const prevStatus = rowRecords.status; // Store previous status
      console.log("rowRecords.status =>", prevStatus);
      console.log("rowRecords=>", rowRecords);
  
      const newStatus = prevStatus === "Active" ? "Inactive" : "Active";
      console.log("newStatus-->", newStatus);
  
      // Clone the rowRecords object to avoid direct mutation
      const recordinrow = { ...rowRecords };
      console.log("recordinrow-->", recordinrow);
  
      delete recordinrow.heads;
      recordinrow.status = newStatus; // Corrected update
  
      // Call API to update status
      const result = await schoolApi.updateFeeDiscounts(recordinrow.id, recordinrow);
      console.log("result->", result);
  
      if (result.success) {
        rowRecords.status = newStatus;
        setUpdateStatus(false);
        toast.success("Status updated successfully!");
      } else {
        rowRecords.status = prevStatus;
        setUpdateStatus(false);
        toast.error(result.message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred while updating the status.");
    }
  };
  

  const handleFeeHeadMaster = (selectedOption) => {
    setSelectedFeeHeadMaster(selectedOption);

    setDiscountRecords((prevRecords) => {
      const updatedFeeHeads = Array.isArray(prevRecords.fee_head_id)
        ? [...prevRecords.fee_head_id]
        : [];

      const newUpdatedFeeHeads = selectedOption.map((ele, index) => {
        return ele.value === updatedFeeHeads[index] ? ele?.value : ele.value;
      });

      const selectedLabel = selectedOption[selectedOption.length - 1]?.value;

      if (selectedLabel && !newUpdatedFeeHeads.includes(selectedLabel)) {
        newUpdatedFeeHeads.push(selectedLabel);
      }

      return {
        ...prevRecords,
        fee_head_id: newUpdatedFeeHeads,
      };
    });
  };

  // console.log('discount-data-->>' , discountRecords);

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>

      <Row className="g-0">
        <Col lg={3} className="mx-3">
          <Link className="nav-link mx-2" to="/">
            Home <i className="fa-solid fa-chevron-right"></i> Fees Discount List
          </Link>
        </Col>

        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        {updateStatus && (
          <Confirm
            show={updateStatus}
            onHide={() => setUpdateStatus(false)}
            changeDiscountStatus={changeDiscountStatus}
            title="Confirm update?"
            message="You are going to update the status. Are you sure?"
            table="discount"
          />
        )}

        <Col lg={12} className="p-lg-4">
          {body ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 15,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col lg={3}>
                  <Filter />
                </Col>
                <Col lg={1} style={{ "margin-top": "-18px" }}>
                  <PaginationOptions labels={labels} />
                </Col>
                <Col lg={4} style={{ "margin-top": "-13px" }}>
                  <InfoPill left="Total Fees Discount" right={body?.length} />
                </Col>
                <Col
                  lg={4}
                  style={{ "margin-top": "2px" }}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  {(userInfo?.userrole === "SYS_ADMIN" ||
                    userInfo?.userrole === "ADMIN" ||
                    canCreate) && (
                    <Button
                      className="btn-light add-new-button" //added by muskan khan
                      style={{ color: "black" }}
                      variant=""
                      disabled={isCurrentSession === false?true:false}
                      onClick={() => setShowModal(true)}
                    >
                      New Fees Discount
                    </Button>
                  )}
                </Col>
              </Row>
              <Table striped className="data-table">
                <TableHeader />
                <TableBody />
              </Table>
              <Pagination />
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={4} />
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>

      <Modal
        show={showModal}
        backdrop="static"
        centered
        className="modal-dialog-scrollable"
        aria-labelledby="contained-modal-title-vcenter"
        onHide={handleCloseModal}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center w-100">Fee Discount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="mt-3">
            <Row>
              <Col lg={6} className="mt-3">
                <Form.Group className="mx-3 fees">
                  <Form.Label className="form-view-label" htmlFor="nameInput">
                    Name
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    name="name"
                    value={discountRecords.name}
                    placeholder="Enter fee discount name"
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col lg={6} className="mt-3">
                <Form.Group className="mx-3">
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicFirstName"
                  >
                    Session
                  </Form.Label>
                  <Form.Select
                   disabled
                    name="sessionid"
                    value={discountRecords.sessionid}
                    onChange={handleChange}
                  >
                    <option value="">-- Select Session --</option>
                    {sessionYear?.map((session) => (
                      <option key={session.id} value={session.id}>
                        {session.year}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg={12} className="mt-3">
                <Form.Group className="mx-3">
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicClass"
                  >
                    Select Fee Head
                  </Form.Label>
                  <Select
                    placeholder="Select fee head"
                    value={selectedFeeHeadMaster}
                    onChange={handleFeeHeadMaster}
                    options={optionFeeHeadMaster}
                    isMulti={true}
                    name="fee_head_id"
                  ></Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg={6} className="mt-3">
                <Form.Group className="mx-3 fees">
                  <Form.Label className="form-view-label" htmlFor="nameInput">
                    Percent
                  </Form.Label>
                  <Form.Control
                    required={discountRecords.amount ? false : true}
                    type="text"
                    id="nameInput"
                    name="percent"
                    value={discountRecords.percent}
                    placeholder="Enter percent"
                    maxLength={3}
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                      handleChange({
                        target: { name: e.target.name, value: numericValue },
                      });
                    }}
                    disabled={discountRecords.amount ? true : false}
                  />
                </Form.Group>
              </Col>
              <Col lg={6} className="mt-3">
                <Form.Group className="mx-3 fees">
                  <Form.Label className="form-view-label" htmlFor="nameInput">
                    Amount
                  </Form.Label>
                  <Form.Control
                    required={discountRecords.percent ? false : true}
                    type="text"
                    id="nameInput"
                    name="amount"
                    value={discountRecords.amount}
                    placeholder="Enter amount"
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                      handleChange({
                        target: { name: e.target.name, value: numericValue },
                      });
                    }}
                    disabled={discountRecords.percent ? true : false}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg={6} className="mt-3">
                <Form.Group className="mx-3">
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicFirstName"
                  >
                    Status
                  </Form.Label>
                  <Form.Select
                    required
                    name="status"
                    value={discountRecords.status}
                    onChange={handleChange}
                  >
                    <option value="">-- Select Status --</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSaveNewDiscount}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FeeDiscount;
